import React from 'react';

import CommonNode from '../../../../components/node/common-node';
import { NodeProvider } from '../../../../context/node-context';
import { getNodeName } from '../../../../utils/getNodeName';
import DeleteFileTaskForm from './forms/delete-file-task-form';
import { deleteFileTaskValidationSchema } from './schema.js';

export default function SftpOperationDeleteFileNode({ data, id, type }) {
  const nodeName = getNodeName(data?.name, 'SFTP Operation Delete File Task');

  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: nodeName,
        altText: 'SFTP Operation Delete File Task',
        defaultLabel: 'SFTP Operation Delete File Task',
      }}
    >
      <CommonNode
        FormComponent={DeleteFileTaskForm}
        schemaResolver={deleteFileTaskValidationSchema}
      />
    </NodeProvider>
  );
}
